
import '../style/app.css';
import Header from "../components/header/header.jsx";
import Footer from "../components/footer/footer.jsx";
import call_Contact from "../components/access_contact.jsx";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcaseMedical, faCode, faGlobe } from '@fortawesome/free-solid-svg-icons';
import TargetComponent from '../components/targetsComponent/targetComponent.jsx';
import { useTranslation } from 'react-i18next';
import ButtonLinkComponent from '../components/buttonLink/buttonLink.jsx';
import BenefitsCardsComponent from '../components/benefitsCardsComponent/benefitsCardsComponent.jsx';
import ReactPlayer from 'react-player';

function App() {
  const { t } = useTranslation();

  const services = [
    {
      title: t('HOME_ECOMMERCE_B2B'),
      description: t('HOME_ECOMMERCE_B2B_DESC'),
      url: "/moreservices/ecommerce",
      img: "/ecommerce_Icon.svg",
      mainImg: "ecommerce-b2b.png"
    },
    {
      title: t('HOME_CRM'),
      description: t('HOME_CRM_DESC'),
      url: "/moreservices/crm",
      img: "/CRM_Icon.svg",
      mainImg: "crm-service.png"
    },
    {
      title: t('HOME_ERP'),
      description: t('HOME_ERP_DESC'),
      url: "/moreservices/erp",
      img: "/ERP_Icon.svg",
      mainImg: "erp-service.png"
    }
  ];

  const serviceCards = [
    {
      imgFontAwesome: faCode,
      title: t('TECH_SERVICES_TITLE'),
      text: t('TECH_SERVICES_TEXT'),
      route: '/techservices',
      mainImg: 'DreamShaper_v7_artificial_intelligence_and_machine_learning_2.jpg',
      className: 'tech',
    },
    {
      imgFontAwesome: faBriefcaseMedical,
      title: t('VMA_TITLE_HOME'),
      text: t('VMA_TEXT_HOME'),
      subtitle: t('VMA_SUBTITLE'),
      mainImg: 'openart-image_WJoUryst_1716397116164_raw.jpg',
      route: '/vma',
    },
    {
      img: 'recruitment.svg',
      title: t('CONSULTING_TITLE'),
      text: t('CONSULTING_TEXT'),
      mainImg: 'businessman-working-futuristic-office.jpg',
      route: '/contractors',
    },
    {
      imgFontAwesome: faGlobe,
      title: t('RECRUITMENT_TITLE_CARD'),
      text: t('RECRUITMENT_TEXT'),
      mainImg: 'medium-shot-woman-working-as-lawyer.jpg',
      route: '/recruitment',
    },
    {
      img: 'investments.svg',
      title: t('INVESTMENTS_TITLE'),
      text: t('INVESTMENTS_TEXT'),
      mainImg: 'hombre-tiro-monedas (1).jpg',
      route: '/investment',
    },
    ...services.map((service) => ({
      img: service.img,
      title: service.title,
      text: service.description,
      route: service.url,
      mainImg: service.mainImg,
    })),
  ];

  const successStories = [
    {
      name: "AT&T",
      title: t('HOME_CLIENT_STORY_1_TITLE'),
      quote: t('HOME_CLIENT_STORY_1_DESC'),
      photo: "https://cdn.icon-icons.com/icons2/2699/PNG/512/att_logo_icon_170510.png"
    },
    {
      name: "Compusoft Integrated solutions inc.",
      title: t('HOME_CLIENT_STORY_3_TITLE'),
      quote: t('HOME_CLIENT_STORY_3_DESC'),
      photo: "https://www.compusoft-is.com/wp-content/uploads/2019/05/logo_final.jpg"
    },
    {
      name: t('HOME_CLIENT_ENVIGADO_NAME'),
      title: t('HOME_CLIENT_ENVIGADO_TITLE'),
      quote: t('HOME_CLIENT_ENVIGADO_DESC'),
      photo: "https://www.envigado.gov.co/sites/alcaldia-municipal-de-envigado-en-antioquia/content/files/002361/118032_escudo_200x200.png"
    }
  ];

  const partnerNetworks = [
    {
      name: "AT&T",
      logo: "AT&T_logo_2016.svg 1.jpg"
    },
    {
      name: "Compusoft",
      logo: "image 1.jpg"
    },
    {
      name: "Vickery Immigration",
      logo: "Vickery Immigration.png",
      dark: true
    },
    {
      name: "Millicom",
      logo: "Millicom.png"
    },
    {
      name: "InnHealth",
      logo: "InnHealth.png"
    },
    {
      name: "Flapz",
      logo: "Flapz.png"
    },
    {
      name: "Microsoft",
      logo: "image Microsoft.png"
    },
    {
      name: "Vergel",
      logo: "Vergel.png"
    },
    {
      name: "Grupo Sura",
      logo: "Grupo Sura.png",
      dark: true
    },
    {
      name: "MicroHome",
      logo: "cropped-Logo-Microhome-05-1 1.jpg"
    },
    {
      name: "Naples Vitality",
      logo: "Naples Vitality.png"
    }
  ];

  const features = [
    {
      title: t("HOME_EMPLOYEE_BENEFITS"),
      text: t('HOME_EMPLOYEE_BENEFITS_DESC'),
      icon: "unbrellaIcon.svg"
    },
    {
      title: t('HOME_PROJECT_TRACKING'),
      text: t('HOME_PROJECT_TRACKING_DESC'),
      icon: "trackingIcon.svg"
    },
    {
      title: t('HOME_CLIENT_INFORMATION'),
      text: t('HOME_CLIENT_INFORMATION_DESC'),
      icon: "clientInfoIcon.svg"
    }
  ];

  const params = useParams();
  useEffect(() => {
    if (params.toService === "to-service") {
      setTimeout(() => {
        const component = document.querySelector(".services-container");
        if (component) {
          component.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else if (params.toService === "to-contact") {
      setTimeout(() => {
        const component = document.querySelector(".contact-us-container");
        if (component) {
          component.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [params]);

  // Component for services cards
  function CardServices({ img, imgFontAwesome, title, subtitle, text, route, className = "", mainImg }) {
    return (
      <div className={`cardServiceContainer ${className}`}>
        <div className='cardMainContainer'>
          <div className="imgMainContainer">
            {mainImg && <img className="mainImg" src={"/img/" + mainImg} alt={`Servicio de ${title}`} />}
          </div>
          <div className='cardTitleContainer'>
            <div className='imgCardService'>
              {imgFontAwesome && <FontAwesomeIcon icon={imgFontAwesome} />}
              {img && <img src={"/img/" + img} alt={`Icono de ${title}`} />}
            </div>
            <div className="cardTitleText">
              <h3 className='cardTitle'>{title}</h3>
              {subtitle && <p className='cardSubtitle'>{subtitle}</p>}
            </div>
          </div>
          <p className='mainTextCardService'>{text}</p>
        </div>
        <ButtonLinkComponent
          translateButton={'HOME_BUTTON_INFO'}
          url={route}
          blank={false}
        />
      </div>
    )
  }

  const servicesRef = useRef(null);
  const [activeStory, setActiveStory] = useState(null);

  // El track renderiza las tarjetas dos veces seguidas (ver ServicesContainer
  // mas abajo) para poder hacer un loop infinito real: en vez de animar de
  // vuelta al inicio (que se ve como si el carrusel retrocediera), cuando el
  // scroll entra en la segunda copia saltamos instantaneamente hacia atras el
  // ancho de una copia completa. Como la segunda copia es identica a la
  // primera, ese salto es invisible y el carrusel se siente infinito hacia
  // adelante.
  const loopBackIfNeeded = () => {
    const el = servicesRef.current;
    if (!el) return;

    const setWidth = el.scrollWidth / 2;
    if (el.scrollLeft >= setWidth) {
      el.scrollLeft -= setWidth;
    }
  };

  const getStep = () => {
    const el = servicesRef.current;
    if (!el) return 0;

    const firstCard = el.querySelector(".cardServiceContainer");
    const track = el.querySelector(".ServicesContainer");
    if (!firstCard || !track) return 0;

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);

    return firstCard.getBoundingClientRect().width + gap;
  };

  const scrollServices = (dir) => {
    const el = servicesRef.current;
    if (!el) return;

    const step = getStep();
    if (!step) return;

    el.scrollBy({
      left: dir * step,
      behavior: "smooth",
    });

    window.setTimeout(loopBackIfNeeded, 500);
  };

  useEffect(() => {
    const el = servicesRef.current;
    if (!el) return;

    const id = setInterval(() => {
      const step = getStep();
      if (!step) return;

      el.scrollBy({ left: step, behavior: "smooth" });
      window.setTimeout(loopBackIfNeeded, 500);
    }, 3500);

    return () => clearInterval(id);
  }, []);

  return (
    <div className="App">
      <Header handleRedirect2={call_Contact} />

      <section className="heroSection">
        <div className="heroInner">
          <div className="heroContainer">

            <div className="heroContent">
              <h1>
                {t("HOME_HERO_TITLE")}
              </h1>

              <p>
                {t("HOME_HERO_SUBTITLE")}
              </p>

              <div className="heroButtons">
                <ButtonLinkComponent
                  className="heroCta"
                  translateButton={"HOME_HERO_CTA"}
                  url={"https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0FQ1s7_Tj8EGOX7a-m0AYO6Q0j5tobKJkIYgHejCi8sWMSLzpcnNrN3enWzyTUBoavXu8hd39W"}
                  blank={true}
                />
              </div>

            </div>

            <div className="heroVisual">
              <img
                src="/img/businessman-working-futuristic-office.jpg"
                alt="Consultoría estratégica y tecnología"
              />
            </div>
          </div>
        </div>
      </section>

      <main className="mainContainerHome">


        <section className="homeServices">
            <div className="homeServicesHead">
              <h2 className="title">{t('OUR_SERVICES')}</h2>
            </div>

            <div className="homeServicesCarousel">
              <button
                className="carouselBtn carouselBtn--left"
                onClick={() => scrollServices(-1)}
                aria-label="Anterior"
              >
                ‹
              </button>

              <div
                className="homeServicesViewport"
                ref={servicesRef}
              >
                <div className="ServicesContainer">
                  {serviceCards.map((card, index) => (
                    <CardServices key={`set1-${index}`} {...card} />
                  ))}
                  {serviceCards.map((card, index) => (
                    <CardServices key={`set2-${index}`} {...card} />
                  ))}
                </div>
              </div>

              <button
                className="carouselBtn carouselBtn--right"
                onClick={() => scrollServices(1)}
                aria-label="Siguiente"
              >
                ›
              </button>
            </div>
        </section>
         
        <section className="people360">
          <h2 className="titleH2">{t('HOME_INTRODUCING_PEOPLE_360')}</h2>
          <p className="textBlack">{t('HOME_ONE_STOP_SOLUTION')}</p>
          <p className="mediumText">{t('HOME_PEOPLE_360_DESC')}</p>
          <BenefitsCardsComponent
            cardsData={features}
          />
          {/* 
          <div className="videoContainer">
            <ReactPlayer
              url={'/img/Vdieo people 360 home.mp4'}
              className='VideoPlayer'
              controls
            />
          </div>
          */ }
        </section>

        <section className="clientStories">
          <h2 className="titleH2">{t('HOME_CLIENT_SUCCESS_STORIES')}</h2>

          <div className='clientsMainContainer'>
            {successStories.map((story, index) => (
              <div key={index} className='clientContainer'>
                <div className="clientInfo">
                  <div className="clientImgContainer">
                    <img src={story.photo} alt={`${story.name} logo`} />
                  </div>

                  <div className="clientNameContainer">
                    <h3>{story.name}</h3>
                    <h4>{story.title}</h4>
                  </div>
                </div>

                <p>{story.quote}</p>

                <button
                  type="button"
                  className="storyReadMore"
                  onClick={() => setActiveStory(story)}
                >
                  {t('BLOG_READ_MORE')}
                </button>
              </div>
            ))}
          </div>

          {activeStory && (
            <div
              className="storyModalOverlay"
              onClick={() => setActiveStory(null)}
              role="dialog"
              aria-modal="true"
              aria-labelledby="story-modal-title"
            >
              <div
                className="storyModal"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="storyModalClose"
                  onClick={() => setActiveStory(null)}
                  aria-label="Cerrar"
                >
                  ×
                </button>

                <div className="storyModalHeader">
                  <div className="storyModalLogo">
                    <img src={activeStory.photo} alt={`${activeStory.name} logo`} />
                  </div>

                  <div className="storyModalHeading">
                    <h3 id="story-modal-title">{activeStory.name}</h3>
                    <h4>{activeStory.title}</h4>
                  </div>
                </div>

                <div className="storyModalBody">
                  <p>{activeStory.quote}</p>
                </div>
              </div>
            </div>
          )}
        </section>

        <section className="partner">
          <h2 className="titleH2">{t('HOME_PARTNERS')}</h2>
          <div className='partnersContainer'>
            <div className="partnersTrack">
              {[...partnerNetworks, ...partnerNetworks].map((partner, index) => (
                <div key={index} className={`partnerLogoTile ${partner.dark ? "partnerLogoTile-dark" : ""}`}>
                  <img src={`/img/${partner.logo}`} alt={`${partner.name} logo`} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="ctaSection">
          <h2>{t('HOME_FINAL_CTA_TITLE')}</h2>

          <ButtonLinkComponent
            className="ctaButton"
            translateButton={'BOOK_APPOINTMENT_BUTTON'}
            url={"https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0FQ1s7_Tj8EGOX7a-m0AYO6Q0j5tobKJkIYgHejCi8sWMSLzpcnNrN3enWzyTUBoavXu8hd39W"}
            blank={true}
          />
        </section>

        {/*<section className='roofSection'>
          <h2>{t('ALL_UNDER_ONE_ROOF_TITLE')}</h2>
          <div className="roofsContainer">
            <TargetComponent
              img={'/img/diverse-group-smiles-teamwork-leads-success-generated-by-ai 1.jpg '}
              text={t('HOME_DRIVING_FUTURE_DESC_1')}
              alt={t('HOME_DRIVING_FUTURE_DESC_1_alt')}
            />
            <TargetComponent
              img={'/img/cinematic-person-is-looking-customer-journey-map 1.jpg'}
              text={t('HOME_DRIVING_FUTURE_DESC_2')}
              alt={t('HOME_DRIVING_FUTURE_DESC_2_alt')}
            />
            <TargetComponent
              img={'/img/person-looking-futuristic-mystical-other-worldly-sky 1.jpg'}
              text={t('HOME_DRIVING_FUTURE_DESC_3')}
              alt={t('HOME_DRIVING_FUTURE_DESC_3_alt')}
            />
            <TargetComponent
              img={'/img/glowing-filament-ignites-inspiration-bright-ideas-indoors-generated-by-ai 1.jpg'}
              text={t('HOME_DRIVING_FUTURE_DESC_4')}
              alt={t('HOME_DRIVING_FUTURE_DESC_4_alt')}
            />
            <TargetComponent
              img={'/img/person-working-futuristic-office 1.jpg'}
              text={t('HOME_DRIVING_FUTURE_DESC_5')}
              alt={t('HOME_DRIVING_FUTURE_DESC_5_alt')}
            />
          </div>
          <ButtonLinkComponent
            translateButton={'BOOK_APPOINTMENT_BUTTON'}
            url={"https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0FQ1s7_Tj8EGOX7a-m0AYO6Q0j5tobKJkIYgHejCi8sWMSLzpcnNrN3enWzyTUBoavXu8hd39W"}
            blank={true}
          />
        </section>
        */ }
      </main>
      <Footer />
    </div>
  );
}


export default App;
